import alertBox from './alertBox';

const error = (content) => alertBox(content, 'error');
const warning = (content) => alertBox(content, 'warning');
const confirm = (content) => alertBox(content, 'confirm');
const customConfirm = (content) => alertBox(content, 'customConfirm');
const confirmWithSave = (content) => alertBox(content, 'confirmWithSave');
const confirmWithNoSave = (content) => alertBox(content, 'confirmWithNoSave');
const success = (content) => alertBox(content, 'success');

const alert = {
  error,
  warning,
  confirm,
  customConfirm,
  success,
  confirmWithSave,
  confirmWithNoSave,
};
export default alert;
